/* eslint-disable import/prefer-default-export */
import api from '../_api';

export const careersService = {
    listAreas(studentUuid) {
        return api.get(`/careers/list_area/student/${studentUuid}`);
    },
    recommendCareers(studentUuid, queryParams) {
        return api.get(`/careers/recommendation/career/student/${studentUuid}`, { params: queryParams });
    },
    getCareer(uuid) {
        return api.get(`/careers/careers/${uuid}/`);
    },
};
